// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"481":"48e1c1db","796":"c095bb0e"}[chunkId] + ".chunk.js";
};